import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';

export default function LPBFilters({ filters, onFilterChange }) {

    const onChange = name => event => {
        onFilterChange(name, event.target.checked )
    };

    return (
        <FormGroup row>
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.ckMissing}
                        onChange={onChange('ckMissing')}
                        value="ckMissing"
                        color="primary"
                    />
                }
                label="Missing"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.ckPI}
                        onChange={onChange('ckPI')}
                        value="ckPI"
                        color="primary"
                    />
                }
                label="PI"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.ckWD}
                        onChange={onChange('ckWD')}
                        value="ckWD"
                        color="primary"
                    />
                }
                label="WD"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.ckNB}
                        onChange={onChange('ckNB')}
                        value="ckNB"
                        color="primary"
                    />
                }
                label="NB"
            />
            <FormControlLabel
                control={
                    <Checkbox
                        checked={filters.ckAWEX}
                        onChange={onChange('ckAWEX')}
                        value="ckAWEX"
                        color="primary"
                    />
                }
                label="AWEX"
            />
        </FormGroup>
    );
                //
            //<FormControlLabel
            //    control={
            //        <Checkbox
            //            checked={filters.ckPrivate}
            //            onChange={onChange('ckPrivate')}
            //            value="ckAWEX"
            //            color="primary"
            //        />
            //    }
            //    label="Private"
            ///>
}